import { ReactNode } from "react";
import { StyledMessageChip } from "./MessageChip.styled";
import { IconManager } from "../core/IconManager/IconManager";
import { IconSizeEnum, FontWeightEnum } from "../../types/AppTypes";
import { BodyTyp } from "../Typography/Typography";

const MessageChip = ({
  message,
  icon,
  color,
}: {
  message: string;
  icon: ReactNode;
  color: string;
}) => {
  return (
    <StyledMessageChip $color={color}>
      {icon && <IconManager size={IconSizeEnum.SMALL}>{icon}</IconManager>}
      <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
        {message}
      </BodyTyp>
    </StyledMessageChip>
  );
};

export default MessageChip;
